import React from 'react'
// hocs
import withObjective from '../withObjective'
// hooks
import { useModalData, useRefetchTree, useShowModal } from 'hooks'
// components
import { Tab } from '@mui/material'
import { DrawerModal, Tabs } from 'components/UI'
import { LoaderWithOverlay } from 'components/UI/Loader'
import { PlanObjectiveActionsMenu } from 'components/CTAs'
// view components
import CompleteAction from 'components/Modals/PlanItems/Action/MinimizedModal/components/DetailsSection/components/CompleteAction'
import DetailsSection from './components/DetailsSection'
import ObjectiveReviewsList from 'components/Modals/PlanItems/Objective/MinimizedModal/components/ReviewsList'
import ObjectiveResourcesList from 'components/Modals/PlanItems/Objective/MinimizedModal/components/ResourcesList'
import CompleteReview from 'components/Modals/PlanItems/components/CompleteReview'
import ApproveReview from 'components/Modals/PlanItems/components/ApproveReview'
import ObjectiveActivitiesList from 'components/Modals/PlanItems/Objective/MinimizedModal/components/ActivitiesList'
import SetColorModal from 'components/Modals/SetColorModal'
// constants
import { ENTITIES, Modals } from 'constants/index'
// themes
import { CloseIcon } from 'components/UI/Icons'
import { Header, OpenIcon, SubHeader, Wrapper } from '../../styles'
// utils
import get from 'lodash/get'
// context
import { ObjectiveContext } from 'context'
// types
import { LogEntityTypes } from 'types/graphql'

const PAPER_PROPS = {
  style: {
    overflowY: 'visible'
  }
}

const ObjectiveMinimizedModal = () => {
  const {
    modalData: { isOpen: isReview }
  } = useModalData({ modalType: Modals.REVIEW_CREATE_MODAL })

  const { showModal } = useShowModal({ modalType: Modals.OBJECTIVE_FULL_MODAL })

  const { hideModal, modalData } = useModalData({ modalType: Modals.OBJECTIVE_MINIMIZED_MODAL })

  const [tab, setTab] = React.useState(0)

  const { entity, isLoading, update, plan } = React.useContext(ObjectiveContext)

  const { isOpen, hideMenu } = modalData

  const openFullModal = () => showModal()

  const handleSetTab = (_, value) => setTab(value)

  useRefetchTree()

  return (
    <DrawerModal
      width={'600px'}
      isOpen={isOpen && !isReview}
      hideModal={hideModal}
      PaperProps={PAPER_PROPS}>
      <Header>
        {!isLoading && (
          <>
            <span>{get(entity, 'description')}</span>
            {!hideMenu && <OpenIcon onClick={openFullModal} />}
            <CloseIcon onClick={hideModal} />
          </>
        )}
      </Header>
      <LoaderWithOverlay isLoading={isLoading} />
      {!isLoading && entity && (
        <>
          <SubHeader>
            {!hideMenu && !plan.locked && <PlanObjectiveActionsMenu hideParent={hideModal} />}
            <Tabs value={tab} onChange={handleSetTab} indicatorColor='primary' textColor='primary' variant={null}>
              <Tab label='Details' />
              <Tab label='Activity' />
              <Tab label='Resources' />
              <Tab label='Reviews' />
            </Tabs>
          </SubHeader>
          {tab === 0 && (
            <>
              <CompleteAction isObjective entity={entity} update={update} />
              <CompleteReview entity={{ ...entity, entityType: ENTITIES.PLAN_OBJECTIVE }} />
              <ApproveReview entity={{ ...entity, entityType: ENTITIES.PLAN_OBJECTIVE }} />
              <Wrapper>
                <DetailsSection
                  entity={{ ...entity, entityType: LogEntityTypes.Objective }}
                  hideModal={hideModal}
                  modalData={modalData}
                />
              </Wrapper>
            </>
          )}
          {tab === 1 && <ObjectiveActivitiesList />}
          {tab === 2 && <ObjectiveResourcesList />}
          {tab === 3 && <ObjectiveReviewsList />}
        </>
      )}
      <SetColorModal />
    </DrawerModal>
  )
}

export default withObjective(ObjectiveMinimizedModal)
